const STRUCT = {
  COST: 'cost',
  EFFECT: 'effect',
  FINE: 'fine',
  ID: 'id',
  TITLE: 'title',
};

export default STRUCT;
